import { DeleteButton, Identifier, Toolbar } from 'react-admin'
import CreateInvoiceDialog from '../actionDialogs/CreateInvoiceDialog'
import CreateDraftButton from '../../drafts/actionButtons/CreateDraftButton'
import { InvoiceType } from '../../GeneratedClients/FreeBillApi'

interface IProps {
  resource?: 'invoices' | 'drafts'
  draftId?: Identifier
  invoiceType: InvoiceType
}

const InvoiceFormToolbar = ({resource, draftId, invoiceType}: IProps) => {
  return (
    <Toolbar >
      {
        (resource === 'invoices' || draftId) &&
        <CreateInvoiceDialog draftId={draftId} invoiceType={invoiceType} />
      }
      <CreateDraftButton />
      <DeleteButton sx={{ml: 2}}/>
    </Toolbar>
  )
}

export default InvoiceFormToolbar